import { Trash2, GripVertical } from "lucide-react";

export const GalleryItem = ({ img, idx, resolveUrl, onDragStart, onDragOver, onDrop, onRemove }) => (
  <div
    draggable
    onDragStart={onDragStart}
    onDragOver={onDragOver}
    onDrop={onDrop}
    data-testid={`admin-gallery-item-${idx}`}
    className="relative group cursor-move"
  >
    <img src={resolveUrl(img.url)} alt="" className="h-28 w-full object-cover rounded" />
    <div className="absolute top-1 left-1 bg-black/70 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
      <GripVertical size={14} />
    </div>
    <button
      data-testid={`admin-gallery-remove-${idx}`}
      onClick={onRemove}
      className="absolute top-1 right-1 bg-black/70 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
    >
      <Trash2 size={14} />
    </button>
  </div>
);
